"use client";

import { c as _c } from "react/compiler-runtime";
import { HStack } from "@navikt/ds-react";
import { useParams, useRouter } from "next/navigation";
import { startTransition, useActionState, useRef } from "react";
import { knappKlikket } from "@/common/analytics/events-and-properties/knappKlikket-properties";
import { getAGOpprettNyPlanHref } from "@/common/route-hrefs";
import { upsertUtkastWithAktivPlanServerAction } from "@/server/actions/upsertUtkastWithAktivPlan";
import { FetchErrorAlert } from "@/ui/FetchErrorAlert";
import { TrackedButton } from "@/ui/TrackedButton";
import { VilDuOverskriveUtkastForAEndrePlanModal } from "../HarAlleredeUtkastModaler/VilDuOverskriveUtkastForAEndrePlanModal";
import { VilDuSletteUtkastForALageNyPlanModal } from "../HarAlleredeUtkastModaler/VilDuSletteUtkastForALageNyPlanModal";
import { VisPdfButtonAG } from "./VisPdfButtonAG";
interface Props {
  planId: string;
  hasUtkast: boolean;
}
export function AktivPlanButtons(t0) {
  const $ = _c(29);
  const {
    planId,
    hasUtkast
  } = t0;
  const {
    push
  } = useRouter();
  const {
    narmesteLederId
  } = useParams();
  const vilDuOverskriveUtkastMedInnholdFraAktivPlanModalRef = useRef(null);
  const vilDuSletteUtkastForALageNyPlanModalRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      error: null
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [t2, upsertUtkastWithAktivPlanAction, isPendingUpsertUtkastWithAktivPlan] = useActionState(upsertUtkastWithAktivPlanServerAction, t1);
  const {
    error: upsertUtkastWithAktivPlanError
  } = t2;
  let t3;
  if ($[1] !== hasUtkast || $[2] !== narmesteLederId) {
    t3 = function handleEndreOppfolgingsplanClick() {
      if (hasUtkast) {
        vilDuOverskriveUtkastMedInnholdFraAktivPlanModalRef.current?.showModal();
      } else {
        startTransition(() => {
          upsertUtkastWithAktivPlanAction(narmesteLederId);
        });
      }
    };
    $[1] = hasUtkast;
    $[2] = narmesteLederId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleEndreOppfolgingsplanClick = t3;
  let t4;
  if ($[4] !== hasUtkast || $[5] !== narmesteLederId || $[6] !== push) {
    t4 = function handleNyPlanClick() {
      if (hasUtkast) {
        vilDuSletteUtkastForALageNyPlanModalRef.current?.showModal();
      } else {
        push(getAGOpprettNyPlanHref(narmesteLederId));
      }
    };
    $[4] = hasUtkast;
    $[5] = narmesteLederId;
    $[6] = push;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleNyPlanClick = t4;
  let t5;
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <VilDuOverskriveUtkastForAEndrePlanModal ref={vilDuOverskriveUtkastMedInnholdFraAktivPlanModalRef} />;
    t6 = <VilDuSletteUtkastForALageNyPlanModal ref={vilDuSletteUtkastForALageNyPlanModalRef} />;
    $[8] = t5;
    $[9] = t6;
  } else {
    t5 = $[8];
    t6 = $[9];
  }
  let t7;
  if ($[10] !== handleEndreOppfolgingsplanClick || $[11] !== isPendingUpsertUtkastWithAktivPlan) {
    t7 = <TrackedButton variant="secondary" onClick={handleEndreOppfolgingsplanClick} loading={isPendingUpsertUtkastWithAktivPlan} tracking={knappKlikket.aktivPlanSide.endreOppfolgingsplan}>Endre oppfølgingsplanen</TrackedButton>;
    $[10] = handleEndreOppfolgingsplanClick;
    $[11] = isPendingUpsertUtkastWithAktivPlan;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== handleNyPlanClick) {
    t8 = <TrackedButton variant="secondary" onClick={handleNyPlanClick} tracking={knappKlikket.aktivPlanSide.lagNyOppfolgingsplan}>Lag en ny plan</TrackedButton>;
    $[13] = handleNyPlanClick;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7 || $[16] !== t8) {
    t9 = <HStack gap="space-16">{t7}{t8}</HStack>;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== narmesteLederId || $[19] !== planId) {
    t10 = <VisPdfButtonAG narmesteLederId={narmesteLederId} planId={planId} />;
    $[18] = narmesteLederId;
    $[19] = planId;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t9) {
    t11 = <HStack justify="space-between">{t9}{t10}</HStack>;
    $[21] = t10;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== upsertUtkastWithAktivPlanError) {
    t12 = <FetchErrorAlert error={upsertUtkastWithAktivPlanError} className="mt-4" />;
    $[24] = upsertUtkastWithAktivPlanError;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t11 || $[27] !== t12) {
    t13 = <>{t5}{t6}{t11}{t12}</>;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
}